<template>
  <div v-if="homework" class="d-flex flex-column">
    <div class="px-3 pt-3">
      <b-form-input
        v-model="homework.name"
        class="mb-3"
        placeholder="Введите название домашнего задания"
        @change="save('name')"
      />
      <b-form-textarea
        v-model="homework.description"
        placeholder="Введите описание домашнего задания"
        @change="save('description')"
      />
    </div>
    <div class="p-5">
      <file-uploader v-model="homework.files" :maxFileCount="50" @change="saveFiles()" />
    </div>
  </div>
</template>

<script>
import FileUploader from "shared/widgets/upload/FileUploader.vue";

export default {
  name: "HomeworkBlock",
  components: { FileUploader },
  props: {
    value: null,
  },
  data() {
    return {
      homework: this.value,
      files: this.value,
    };
  },
  methods: {
    save(fieldName) {
      if (!this.homework[fieldName]) {
        return;
      }

      this.$emit("input", {
        id: this.homework.id,
        [fieldName]: this.homework[fieldName],
      });
      this.$emit("update");
    },
    saveFiles() {
      this.$emit("input", {
        id: this.homework.id,
        files: this.homework.files.filter((f) => typeof f.id !== "string"),
      });
      this.$emit("update");
    },
  },
};
</script>
